var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3213({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4755 22.8455L32 21.382L31.5245 22.8455L29.6161 28.7188H23.4405H21.9016L23.1466 29.6234L28.1428 33.2533L26.2344 39.1266L25.7589 40.5902L27.0038 39.6857L32 36.0557L36.9962 39.6857L38.2411 40.5902L37.7656 39.1266L35.8572 33.2533L40.8534 29.6234L42.0984 28.7188H40.5595H34.3839L32.4755 22.8455Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11V10.5C20 5.2533 15.7467 1 10.5 1V1C5.2533 1 1 5.2533 1 10.5V12.1339C1 14.9406 2.06004 17.6437 3.96795 19.7023L20 37",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11V10.5C20 5.2533 24.2533 1 29.5 1V1C34.7467 1 39 5.2533 39 10.5V12.2574C39 14.9739 37.9209 17.5791 36 19.5V19.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3213);
export default __webpack_public_path__ + "static/media/Group 3213.56d841c79265e50c678d5e4abc5f7da1.svg";
export { ForwardRef as ReactComponent };